import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function ProofSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-24 px-4" style={{
    background: 'var(--color-surface)'
  }} data-id="element-288">
      <div className="max-w-2xl mx-auto" data-id="element-289">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7
      }} className="mb-10" data-id="element-290">
          <p className="text-sm font-semibold tracking-widest uppercase mb-6" style={{
          color: 'var(--color-accent)'
        }} data-id="element-291">
            Por qué esto funciona
          </p>

          <h2 className="text-3xl md:text-4xl font-black mb-8 leading-tight" style={{
          fontFamily: 'Playfair Display, serif',
          color: 'var(--color-text)'
        }} data-id="element-292">
            El audio no es un formato nuevo.
          </h2>

          <p className="text-lg leading-relaxed mb-6" style={{
          color: 'var(--color-text-muted)'
        }} data-id="element-293">
            Es el formato más antiguo de transferencia de conocimiento que
            existe.
          </p>

          <p className="text-lg leading-relaxed mb-10" style={{
          color: 'var(--color-text-muted)'
        }} data-id="element-294">
            Las culturas antiguas transmitían sabiduría oralmente — porque
            sabían que el oído activa algo que el ojo no activa de la misma
            forma.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        delay: 0.3,
        duration: 0.7
      }} data-id="element-295">
          <div className="py-8 px-8 mb-10 rounded-sm" style={{
          background: '#0f0f0f',
          borderLeft: '4px solid var(--color-accent)'
        }} data-id="element-296">
            <p className="text-sm font-semibold tracking-widest uppercase mb-4" style={{
            color: 'var(--color-accent)'
          }} data-id="element-297">
              Neurociencia moderna
            </p>
            <p className="text-xl italic leading-relaxed" style={{
            fontFamily: 'Playfair Display, serif',
            color: 'var(--color-text)'
          }} data-id="element-298">
              "El audio en estado de movimiento o relajación profunda bypasea el
              filtro crítico consciente y accede directamente al sistema límbico
              — donde viven las creencias."
            </p>
          </div>

          <div className="space-y-6" data-id="element-299">
            <div className="p-6 rounded-sm" style={{
            background: 'var(--color-surface-2)',
            border: '1px solid var(--color-border)'
          }} data-id="element-300">
              <p className="text-base leading-relaxed" style={{
              color: 'var(--color-text-muted)'
            }} data-id="element-301">
                Los protocolos de meditación estratégica no son relajación.{' '}
                <strong style={{
                color: 'var(--color-text)'
              }} data-id="element-302">
                  Son acceso directo al sistema de creencias instalado.
                </strong>
              </p>
            </div>

            <div className="p-6 rounded-sm" style={{
            background: 'var(--color-surface-2)',
            border: '1px solid var(--color-border)'
          }} data-id="element-303">
              <p className="text-base leading-relaxed" style={{
              color: 'var(--color-text-muted)'
            }} data-id="element-304">
                Y la repetición constante — en formatos diseñados para el
                subconsciente —{' '}
                <strong style={{
                color: 'var(--color-accent)'
              }} data-id="element-305">
                  es lo que produce el cambio que el conocimiento consciente
                  solo nunca logra.
                </strong>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}